export const DATE_FORMAT_HTML5 = "YYYY-MM-DD";
